// @vendor
import React, { ReactNode } from 'react';

// @context
import { useCommittedCapacityContext } from '../../context/committed-capacity.context';

// @components
import ExpiredTender from '../ProcessingTender/ExpiredTender/ExpiredTender';
import CommittedCapacityNoResult from '../CommittedCapacityNoResult/CommittedCapacityNoResult';
import { CommittedCapacityLandingPageSpinner } from '../LandingPage/LandingPage';

// @styles
import committedCapacityStyles from './PrebookingValidations.scss'

function PrebookingValidations({ children }: { children: ReactNode }) {
  const {
    errorLoadTenderDetails,
    initialLoadingMessage,
    isLoadExpired,
    tenderDetails
  } = useCommittedCapacityContext();

  if (initialLoadingMessage) {
    return <CommittedCapacityLandingPageSpinner message={initialLoadingMessage} />
  }

  if (errorLoadTenderDetails) {
    return (
      <CommittedCapacityNoResult
        content={
          <span>Error getting tender details</span>
        }
        subtitle=''
      />
    );
  }

  if (isLoadExpired) {
    return <ExpiredTender />;
  }

  if (tenderDetails.isLoadUpdated) {
    return (
      <CommittedCapacityNoResult
        content={
          <>
            <span>Load #{tenderDetails.loadNumber} has recently been updated.</span>
            <br />
            <span>If you are still eligible to cover this load you will receive a new Load Tender email with the new updates for your review and confirmation.</span>
          </>
        }
      />
    );
  }

  return <div className={committedCapacityStyles.committedCapacity}>{children}</div>;
}

export default PrebookingValidations;
